"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePlugin = void 0;
const inversify_1 = require("inversify");
const lifecycle_1 = require("../application/lifecycle");
const hooks_1 = require("../hooks");
/**
 * Base implementation of an application plugin.
 */
let BasePlugin = class BasePlugin {
    /**
     * Override this method if your plugin needs to run a task after the application has been configured.
     * For example, an HTTP server that starts listening.
     * At this step, ApplicationReadyHook has already been triggered.
     * @param ctx - The application context.
     */
    start(ctx) {
        // Do nothing by default, can be overriden
    }
    /** {@inheritDoc IApplicationLifecycle.applicationReady} */
    applicationReady(hook) {
        // Do nothing by default, can be overriden
    }
    /** {@inheritDoc IApplicationLifecycle.applicationReady} */
    applicationStarted(hook) {
        // Do nothing by default, can be overriden
    }
    /** {@inheritDoc IApplicationLifecycle.beforeApplicationExit} */
    beforeApplicationExit(hook) {
        // Do nothing by default, can be overriden
    }
};
__decorate([
    hooks_1.Hook(lifecycle_1.ApplicationReadyHook),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [lifecycle_1.ApplicationReadyHook]),
    __metadata("design:returntype", Object)
], BasePlugin.prototype, "applicationReady", null);
__decorate([
    hooks_1.Hook(lifecycle_1.ApplicationStartedHook),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [lifecycle_1.ApplicationStartedHook]),
    __metadata("design:returntype", Object)
], BasePlugin.prototype, "applicationStarted", null);
__decorate([
    hooks_1.Hook(lifecycle_1.BeforeApplicationExitHook),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [lifecycle_1.BeforeApplicationExitHook]),
    __metadata("design:returntype", Object)
], BasePlugin.prototype, "beforeApplicationExit", null);
BasePlugin = __decorate([
    inversify_1.injectable()
], BasePlugin);
exports.BasePlugin = BasePlugin;
//# sourceMappingURL=model.js.map